import { Box, Checkbox, TableCell, TableHead, TableRow, TableSortLabel } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { IEnhancedTableHeaderProps } from "../../../Typings/SortableTable";

export function EnhancedTableHead(props: IEnhancedTableHeaderProps) {
  const {
    order,
    orderBy,
    onRequestSort,
    columns,
    isEditing,
    numSelected,
    rowCount,
    onSelectAllClick,
    selectAllEnabled = true,
    isChecked,
    isIndeterminate,
  } = props;
  const createSortHandler = (property: string) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };
  const isActive = (propName: string) => orderBy?.toLowerCase() === propName.toLowerCase();

  const indeterminate = isIndeterminate ?? (numSelected > 0 && numSelected < rowCount);
  const checked = isChecked ?? (rowCount > 0 && numSelected === rowCount);

  return (
    <TableHead>
      <TableRow>
        {isEditing ? (
          <TableCell
            data-test="enhanced-table-head-cell"
            sx={{ backgroundColor: "white", borderColor: "rgb(160,160,160)" }}
          >
            <Checkbox
              size="small"
              disabled={!selectAllEnabled}
              data-test="select-all-checkbox"
              color="primary"
              indeterminate={indeterminate}
              checked={checked}
              onChange={onSelectAllClick}
              inputProps={{
                "aria-label": "Select all",
              }}
            />
          </TableCell>
        ) : null}
        {columns
          .sort((a, b) => {
            return a.order - b.order;
          })
          .map((headCell) => (
            <TableCell
              data-test={`enhanced-table-head-cell-${headCell.propName}`}
              key={headCell.propName}
              aria-label={`table header ${headCell?.label}`}
              align="left"
              sortDirection={isActive(headCell.propName) ? order : false}
              sx={{ backgroundColor: "white", borderColor: "rgb(160,160,160)" }}
            >
              <TableSortLabel
                active={isActive(headCell.propName)}
                direction={isActive(headCell.propName) ? order : "asc"}
                onClick={createSortHandler(headCell.propName)}
                sx={{
                  fontWeight: "bold",
                }}
              >
                {isActive(headCell.propName) ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc" ? "sorted descending" : "sorted ascending"}
                  </Box>
                ) : null}
                {headCell.label}
              </TableSortLabel>
            </TableCell>
          ))}
      </TableRow>
    </TableHead>
  );
}
